// Centralized luxury imagery. Branded EID assets are now re-hosted through
// the in-app Object Storage so they serve from the canonical app domain
// (avoids cross-origin issues inside the Emergent preview iframe and any
// CDN quirks on customer-assets.*). Update via /admin or upload through CMS.

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const file = (p) => `${BACKEND}${p}`;

export const IMAGES = {
  // Brand assets
  elliott_logo: file(
    "/api/files/eid-developments/images/ed8a810c-58b1-4631-9c35-d64c9310b353.jpg"
  ),

  // BRANDED Elliott Towers exterior renders (uploaded by client)
  elliott_twin_towers: file(
    "/api/files/eid-developments/images/d9266408-600f-4127-95b8-fe36bb5cf3ad.jpg"
  ),
  elliott_towers_dusk: file(
    "/api/files/eid-developments/images/f7cf7bc7-7c5f-4ac2-a261-95f621884516.jpg"
  ),
  branded_entrance: file(
    "/api/files/eid-developments/images/dc023afa-918a-44b1-b983-7d6567103de6.jpg"
  ),

  // Branded EID interior renders
  luxury_condo_interior: file(
    "/api/files/eid-developments/images/11cad6d7-8ea8-4f5a-8a8c-071c1a7906c6.jpg"
  ),
  luxury_hotel_lobby: file(
    "/api/files/eid-developments/images/5f98955c-ec41-4864-9a57-1902f392b3fd.jpg"
  ),
  retail_interior: file(
    "/api/files/eid-developments/images/fb2fe4f5-20ad-4d43-9c91-4c1637506ff3.jpg"
  ),
  luxury_amenity_spa: file(
    "/api/files/eid-developments/images/58cd5aba-0b0a-4d3e-9c16-0397699dcbc6.jpg"
  ),
  bayshore_waterfront: file(
    "/api/files/eid-developments/images/a2147e74-c5e3-4717-8d98-a4eaa8a261db.webp"
  ),
  branded_kitchen: file(
    "/api/files/eid-developments/images/ecfc8731-2e85-44dc-b32a-b0d68d8d246e.jpg"
  ),
  private_vault: file(
    "/api/files/eid-developments/images/45d406c8-07dd-4896-80f5-4d33e800d186.jpg"
  ),

  // Founder portrait (branded)
  founder_ceo_portrait: file(
    "/api/files/eid-developments/images/8e68fc71-db27-4771-a432-d3b4c16c36e7.jpg"
  ),

  // Branded boardroom / Class AAA office interior
  boardroom_office: file(
    "/api/files/eid-developments/images/5557cd4e-e253-4cb3-aa10-efcd8f2f23f2.png"
  ),
  // Branded lobby with elevators (used as Engineered-to-Landmark feature image)
  lobby_elevators: file(
    "/api/files/eid-developments/images/9c37f8c4-f60d-44e5-bc56-1677e39eda5a.png"
  ),
  // Branded fitness center / wellness suite
  fitness_center: file(
    "/api/files/eid-developments/images/acded7d0-120b-46bd-bb3d-29c663c17a2a.png"
  ),
  // Branded great room / bayfront living room with floor-to-ceiling sunset views
  grand_living_room: file(
    "/api/files/eid-developments/images/dc4331be-bf73-4147-824b-c6a5fcaef68c.png"
  ),

  // Tampa skyline (branded golden-hour downtown Tampa panorama)
  tampa_skyline: file(
    "/api/files/eid-developments/images/1d8d752a-c589-4160-8392-74eaa520bc06.webp"
  ),

  // Generated/stock for items user hasn't supplied yet
  observation_deck_view:
    "https://static.prod-images.emergentagent.com/jobs/c02a2ba5-1aef-4db1-9543-8b62380532fb/images/f7f65a9305dcf0ac82fd89152a76e13b16b4f9781a365d0c7f7c6c78a110b19d.png",
  architectural_close_up:
    "https://images.unsplash.com/photo-1691425700573-5e2e6e4f6157?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmFsJTIwY2xvc2UlMjB1cCUyMGZhY2FkZXxlbnwwfHx8fDE3Nzg5NTEzMDF8MA&ixlib=rb-4.1.0&q=85",
  construction_site:
    "https://images.unsplash.com/photo-1689264337786-11efb44e298c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxjb25zdHJ1Y3Rpb24lMjBzaXRlJTIwY3JhbmUlMjBzdW5zZXR8ZW58MHx8fHwxNzc4OTUxMzIwfDA&ixlib=rb-4.1.0&q=85",
  rooftop_pool:
    "https://static.prod-images.emergentagent.com/jobs/c02a2ba5-1aef-4db1-9543-8b62380532fb/images/0aff43aab0a77b029eb9b808f9c33399fca02077938fc67e45044ee2b5543e9a.png",
  aerial_city:
    "https://images.unsplash.com/photo-1673574672395-5f8bd3c2ed5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwzfHxUYW1wYSUyMHNreWxpbmUlMjBuaWdodHxlbnwwfHx8fDE3Nzg5NTEzMDB8MA&ixlib=rb-4.1.0&q=85",
};

export default IMAGES;
